import callWebGate from './callWebGate';
import debug from 'debug';
import { jsonStringify } from 'utils/storageHelpers';
const log = debug('addAccount');
const url = 'adgenerator/v1/account';


export function addAccount(data, accessToken, webGate = callWebGate) {
  log('Add account information: %s', data);
  const opts = {
    method: 'POST',
    body: jsonStringify(data),
  };

  return webGate(url, accessToken, opts)
    .then(r => {
      if (!r.ok) return Promise.reject(r);
      return Promise.resolve(r.status);
    });
}

export function getAccount(accessToken, webGate = callWebGate) {
  const opts = {
    method: 'GET',
  };

  return webGate(url, accessToken, opts)
    .then(r => {
      switch (r.status) {
        case 200:
          return r.json();
        case 404:
          return Promise.resolve(null);
        default:
          return Promise.reject(new Error(r.statusText));
      }
    });
}

export function updateAccount(data, accessToken, webGate = callWebGate) {
  log('Update account information: %s', data);
  const opts = {
    method: 'PUT',
    body: jsonStringify(data),
  };

  return webGate(url, accessToken, opts)
    .then(r => {
      if (!r.ok) return Promise.reject(r);
      return Promise.resolve(r.status);
    });
}



// WEBPACK FOOTER //
// ./src/api/account.js